import './go-top/go-top'

// swiper slider
import './sliderSwiper/swiper.min.js'

// smoothScroll
import './smoothScroll/smoothScroll.js'